import { createSelector } from 'reselect'

const getLocalState = state => state.ferme

export const getList = createSelector(
	getLocalState,
	ferme => ferme || []
)
